import { Wrapper } from 'AppReact';
import styled from 'styled-components';

export default Wrapper(styled.div`
  display: flex; 
  align-items: center; 
  overflow: auto; 

  scrollbar-width: thin;
  scrollbar-color: #E3E3E3 transparent;

  overflow: overlay !important;

  ::-webkit-scrollbar {
    width: 16px;
    height: 16px;
    background: transparent;
  }

  ::-webkit-scrollbar-track-piece  {
    background: transparent;
  }

  ::-webkit-scrollbar-thumb:vertical {
    background: linear-gradient(to left, #E3E3E3 4px, transparent 0%);
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb:horizontal {
    background: linear-gradient(to top, #E3E3E3 4px, transparent 0%);
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #E3E3E3;
  }
`)
